export const skinnySideBarWidth = 263;
